// extracted by mini-css-extract-plugin
export default {"celebrate":"Celebrate-module__celebrate--W7jkS","copilotRun":"Celebrate-module__copilotRun--sKpgB"};